import React from 'react';

export const Clocking: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
    <svg viewBox='0 0 16 16' {...props}>
      <g fill='currentColor'>
        <path
          d='M8,0a8,8,0,1,0,3.985,14.93l-.471-.811A7.015,7.015,0,0,1,8,15.063a7.054,7.054,0,1,1,6.125-3.54V10.375h-.937v2.813H16V12.25H14.781A8,8,0,0,0,8,0ZM8,0' />
        <path
          d='M95.178,90a5.178,5.178,0,1,0,5.178,5.178A5.206,5.206,0,0,0,95.178,90Zm3.275,5.646H94.71V91.871h.936V94.71h2.807Zm0,0'
          transform='translate(-87.178 -87.178)' />
      </g>
    </svg>
  )
;
